/* eslint-disable max-len */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
// import _ from 'lodash';
import clone from 'clone';
import {
  Button,
  Form,
  Grid,
  Segment,
} from 'semantic-ui-react';
import 'react-day-picker/lib/style.css';
import { required } from '@mhub/web-validations';
import AppForm from './AppForm';

export default class ProjectHimsSettingsForm extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    projectID: PropTypes.string,
    companyHimsTokens: PropTypes.arrayOf(PropTypes.shape({
      developerCode: PropTypes.string,
      developerName: PropTypes.string,
    })),
    himsSettings: PropTypes.arrayOf(PropTypes.shape({
      himsDeveloperCode: PropTypes.string,
      himsDeveloperName: PropTypes.string,
      himsDeveloperLicense: PropTypes.string,
      himsDevelopmentCode: PropTypes.string,
      himsDevelopmentName: PropTypes.string,
    })),
    disabled: PropTypes.bool,
  }
  static getPropsToState = (props) => {
    const { companyHimsTokens } = props;
    return {
      companyHimsTokens: companyHimsTokens.map(cht => ({
        value: cht.developerCode,
        text: `${cht.developerCode} - ${cht.developerName}`,
      })),
    };
  }
  constructor(props) {
    super(props);
    const state = ProjectHimsSettingsForm.getPropsToState(props);
    const data = props.himsSettings || [];
    const validations = [];
    data.forEach((d, idx) => {
      validations[idx] = this.newValidationObject();
    });
    this.state = {
      ...state,
      oriData: clone(data),
      data,
      validations,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = ProjectHimsSettingsForm.getPropsToState(nextProps);
    let { validations } = this.state;
    if (nextProps.projectID !== this.props.projectID) {
      const data = nextProps.himsSettings || [];
      state.oriData = clone(data);
      state.data = data;
      validations = [];
      state.data.forEach((d, idx) => {
        validations[idx] = this.newValidationObject();
      });
    }
    this.setState({
      ...state,
      validations,
    });
  }
  handleOnChange = (data, validations = this.state.validations) => {
    this.setState({ data, validations });
    if (this.props.onChange) {
      this.props.onChange(data);
    }
  }
  validate = async () => {
    const allValidations = {};
    this.state.validations.forEach((v, idx) => {
      allValidations[`himsDeveloperCode_${idx}`] = v.himsDeveloperCode;
      allValidations[`himsDeveloperName_${idx}`] = v.himsDeveloperName;
      allValidations[`himsDeveloperLicense_${idx}`] = v.himsDeveloperLicense;
      allValidations[`himsDevelopmentCode_${idx}`] = v.himsDevelopmentCode;
      allValidations[`himsDevelopmentName_${idx}`] = v.himsDevelopmentName;
    });
    const data = {};
    this.state.data.forEach((d, idx) => {
      data[`himsDeveloperCode_${idx}`] = d.himsDeveloperCode;
      data[`himsDeveloperName_${idx}`] = d.himsDeveloperName;
      data[`himsDeveloperLicense_${idx}`] = d.himsDeveloperLicense;
      data[`himsDevelopmentCode_${idx}`] = d.himsDevelopmentCode;
      data[`himsDevelopmentName_${idx}`] = d.himsDevelopmentName;
    });
    return AppForm.validate(allValidations, data);
  }
  handleInputChange = ({ name, value }, idx) => {
    let { data } = this.state;
    const { companyHimsTokens } = this.props;
    if (name === 'himsDeveloperCode') {
      const himsToken = companyHimsTokens.find(cht => cht.developerCode === value);
      if (himsToken) {
        // change all
        data = data.map(d => ({
          ...d,
          himsDeveloperCode: himsToken.developerCode,
          himsDeveloperName: himsToken.developerName,
        }));
      }
    } else {
      data[idx][name] = value;
    }
    this.handleOnChange(data);
  }
  handleAddRow = () => {
    const { projectID } = this.props;
    const { data, validations } = this.state;
    if (data.length >= 10) {
      return;
    }
    data.push({
      projectID,
      himsDeveloperCode: data.length > 0 ? data[0].himsDeveloperCode : '',
      himsDeveloperName: data.length > 0 ? data[0].himsDeveloperName : '',
      himsDeveloperLicense: '',
      himsDevelopmentCode: '',
      himsDevelopmentName: '',
    });
    validations.push(this.newValidationObject());
    this.handleOnChange(data, validations);
  }
  handleRemoveRow = (idx) => {
    const { data, validations } = this.state;
    data.splice(idx, 1);
    validations.splice(idx, 1);
    this.handleOnChange(data, validations);
  }
  newValidationObject = () => ({
    himsDeveloperCode: createRef(),
    himsDeveloperName: createRef(),
    himsDeveloperLicense: createRef(),
    himsDevelopmentCode: createRef(),
    himsDevelopmentName: createRef(),
  })
  renderRow = (hs, idx) => {
    const { disabled } = this.props;
    const { companyHimsTokens, validations } = this.state;
    const validationRef = validations[idx];
    const asterisk = disabled ? '' : '*';
    return (
      <Grid.Row key={idx}>
        <Grid.Column>
          <Segment>
            <Form.Group widths="equal">
              <AppForm.Select
                label="Developer Code - Kod Pemaju"
                validateName={`himsDeveloperCode_${idx}`}
                name="himsDeveloperCode"
                fluid
                value={hs.himsDeveloperCode}
                options={companyHimsTokens}
                onChange={(e, d) => this.handleInputChange(d, idx)}
                placeholder={`Select Developer Code${asterisk}`}
                validation={disabled ? null : [required]}
                ref={validationRef ? validationRef.himsDeveloperCode : null}
                disabled={disabled || companyHimsTokens.length === 0 || idx > 0}
              />
              <AppForm.Input
                label="Developer Name - Nama Pemaju"
                validateName={`himsDeveloperName_${idx}`}
                name="himsDeveloperName"
                fluid
                value={hs.himsDeveloperName}
                validation={disabled ? null : [required]}
                ref={validationRef ? validationRef.himsDeveloperName : null}
                disabled
              />
            </Form.Group>
            <Form.Group widths="equal">
              <AppForm.Input
                label="Developer License Number - No Lesen"
                validateName={`himsDeveloperLicense_${idx}`}
                name="himsDeveloperLicense"
                fluid
                value={hs.himsDeveloperLicense}
                onChange={(e, d) => this.handleInputChange(d, idx)}
                validation={disabled ? null : [required]}
                ref={validationRef ? validationRef.himsDeveloperLicense : null}
                disabled={disabled}
              />
              <AppForm.Validate
                label="Development Project Code - Kod Pemajuan"
                validateName={`himsDevelopmentCode_${idx}`}
                name="himsDevelopmentCode"
                onChange={(e, d) => this.handleInputChange(d, idx)}
                validation={disabled ? null : [required]}
                ref={validationRef ? validationRef.himsDevelopmentCode : null}
              >
                <Form.Input
                  fluid
                  label="Development Project Code - Kod Pemajuan"
                  name="himsDevelopmentCode"
                  value={hs.himsDevelopmentCode}
                  disabled={disabled}
                />
                <p><small style={disabled ? { opacity: 'calc(.2025)', color: 'rgba(0,0,0,.87)' } : {}}>(This is required to pull information from HIMS)</small></p>
              </AppForm.Validate>
            </Form.Group>
            <Form.Group widths="equal" style={{ alignItems: 'end', marginBottom: 0 }}>
              <AppForm.Input
                label="Development Project Name - Nama Pemajuan"
                validateName={`himsDevelopmentName_${idx}`}
                name="himsDevelopmentName"
                fluid
                value={hs.himsDevelopmentName}
                onChange={(e, d) => this.handleInputChange(d, idx)}
                validation={disabled ? null : [required]}
                ref={validationRef ? validationRef.himsDevelopmentName : null}
                disabled={disabled}
              />
              <div style={{ width: '100%', textAlign: 'right', paddingRight: '0.5em' }}>
                <Button
                  size="tiny"
                  type="button"
                  compact
                  negative
                  icon="remove"
                  content="Remove"
                  disabled={disabled}
                  onClick={() => this.handleRemoveRow(idx)}
                />
              </div>
            </Form.Group>
          </Segment>
        </Grid.Column>
      </Grid.Row>
    );
  }
  render() {
    const { disabled } = this.props;
    const { data } = this.state;
    return (
      <Grid verticalAlign="middle">
        <Grid.Row>
          <Grid.Column mobile={11} tablet={13} computer={13}>
            <p style={disabled ? { opacity: 'calc(.2025)', color: 'rgba(0,0,0,.87)' } : {}}>Retrieve data from HIMS and fill in the boxes below. Ensure the data is accurate.</p>
          </Grid.Column>
          <Grid.Column mobile={5} tablet={3} computer={3} textAlign="right">
            <Button
              primary
              style={{ margin: 0 }}
              type="button"
              size="small"
              icon="add"
              content="Add"
              disabled={disabled || data.length >= 10}
              onClick={this.handleAddRow}
            />
          </Grid.Column>
        </Grid.Row>
        {
          data && data.length > 0 &&
          data.map((hs, idx) => this.renderRow(hs, idx))
        }
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectHimsSettingsForm.jsx